import { CookieService } from 'ngx-cookie-service';
import { ModulesService } from './tools/modules.service';
import { Router } from '@angular/router';
import { Http, Headers, RequestOptions } from '@angular/http';
import { ConstantsService } from './constants.service';
import { Injectable } from '@angular/core';

/**
* Tipos de créditos
*/
export enum ModulosARK {
  CatalogoReportes,
  Gastos = 12,
  AutorizarCuentasPorPagar = 13,
  ReporteCuentasPorCobrar = 17,
  ReporteCuentasPorPagar = 18,
  Configuracion = 19,
  EliminarContratos = 20,
  PreautorizarCuentasPorPagar = 21,
  ReporteResumenDeObra = 22,
  ReportePorInversionista = 23,
  ReporteBalanceKr = 24,
  ReportePuntoDeEquilibrio = 25,
  ReportePorObra = 26,
  ReporteResumenDeDiferencia = 27,
  ReporteSaldos = 28,
  ReporteDepositoGarantia = 31,
  ReporteResumenOyv = 31,
  ActualizarEliminarCuentasPorPagar = 32,
  ReporteCobranza = 33,
  CarpetaBlanca = 34,
  EstadoCuentaClientes = 35
}

export enum TipoPermiso {
  Lectura,
  Escritura
}

@Injectable()
export class AutenticacionService {

  public auth_user;
  public auth_token;
  private service_url;
  constructor(private constantsService: ConstantsService, private http: Http, private router: Router, private modulesService: ModulesService, private cookieService: CookieService) {
    this.service_url = this.constantsService.apiURL;
    //this.startAuth();
  }

  login(username, password) {
    const data = {
      'username': username,
      'password': password
    };

    return this.http.post(this.service_url + '/login', data);
  }

  setUser(content) {
    if(content == undefined) {
      this.auth_user = undefined; // reseting auth user
      this.auth_token = undefined; // reseting auth token
      this.cookieService.delete('ark-token'); // when receive content on undefined, It's means we want to refresh out cookie
    } else {
      // saving auth local user
      //console.log("login content: ",content);
      this.auth_user = content.user;
      if (content.token) { // when we receive token override the cookie
        //this.cookieService.set('ark-token', content.token.access_token);
        var tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate()+1);
        this.cookieService.set('ark-token', content.token.access_token,tomorrow,'/',null,false, 'Lax');
        console.log("content setUser: ",content);
        this.auth_token = content.token;
      } else if (!content.token && !this.getToken()) { // when we don't receive token and we don't have token on our cookie, send to login
        this.router.navigate(['login']);
      } else { // when we don't receive token, It's means we have the token on cookie
        this.auth_token = this.getToken();
      }
    }
  }

  startAuth() {
    const token = this.getToken();

    if (token && !this.auth_token) {
      this.getUser().subscribe(response => {
        const content = response.json().content;
        this.setUser(content);
      }, error => {
        console.log('startAuth - error ', error);
      });
    }
  }

  killUser() {
    this.setUser(undefined);
    this.router.navigate(['login']);
  }

  closeKey() {
    return this.http.delete(this.service_url + '/logoutKey', this.getAuthHeaders());
  }

  getUser() {
    return this.http.get(this.service_url + '/datosUsuario', this.getAuthHeaders());
  }
  getToken() {
    return this.cookieService.get('ark-token');
  }
  getAuthHeaders() {
    const token = this.getToken();
    if(!token) {
      this.router.navigate(['login']);
    }

    const requestOptions = new RequestOptions({
      'headers': new Headers({
        'Authorization': 'Bearer ' + token
      })
    });

    return requestOptions;
  }

  recuperarPassword(username) {
    const data = {
      'username': username
    }
    return this.http.post(this.service_url + '/recover', data);
  }

  generarPassword(token, old_password, new_password, key_password) {
    const data = {
      'token': token,
      'old_password': old_password,
      'new_password': new_password,
    };
    if (key_password) {
      data['key_password'] = key_password;
    }
    return this.http.post(this.service_url + '/change', data);
  }

  logout() {
    return this.http.post(this.service_url + '/logout',{}, this.getAuthHeaders());
  }

  // receive a permission id, example 1
  hasPermission(permissionId, read = false) {
    const token = this.getToken();
    if(!token || !this.auth_user) {
      return false;
    }

    const permission = (read)?'escritura': 'lectura'; // if the second parameter of our function is true, we want to filter write permition
    let hp = false; //haspermissions
    this.auth_user.permisos_usuarios.forEach(p => {
      if (permissionId == p.idPermisos && (p[permission] == 1 || p[permission] == true)) {
        hp = true;
      }
    });

    return hp;
  }

  public tienenPermisos(modulo: ModulosARK, permiso: TipoPermiso) {
    const token = this.getToken();
    if(!token || !this.auth_user) {
      return false;
    }

    const permission = (permiso === TipoPermiso.Escritura) ? 'escritura': 'lectura'; // if the second parameter of our function is true, we want to filter write permition
    let hp = false; //haspermissions
    console.log(this.auth_user.permisos_usuarios);
    this.auth_user.permisos_usuarios.forEach(p => {
      // console.log("p type: ",typeof(p.idPermisos));

      if (modulo === parseInt(p.idPermisos) && (p[permission] == 1 || p[permission] == true)) {
        hp = true;
      }
    });

    return hp;
  }

  // receive a array with id of permission, example: [1,2,3]
  hasPermissions(permissionsIds, read = false) {
    const token = this.getToken();
    if(!token || !this.auth_user) {
      return false;
    }

    let hp = false; //haspermissions
    const permission = (read)?'escritura': 'lectura'; // if the second parameter of our function is true, we want to filter write permition
    this.auth_user.permisos_usuarios.forEach(permiso_usuario => {
      permissionsIds.forEach(permisos_seccion => {
        if (permisos_seccion == permiso_usuario.idPermisos && (permiso_usuario[permission] == 1 || permiso_usuario[permission] == true)) {
        hp = true;
      }
      });
    });

    return hp;
  }


  canExport() {
    if (!this.auth_user) {
      return false;
    }
    const canExport = (this.auth_user.exportacion == 1)?true:false;
    return canExport
  }

  canSecurity() {
    if (!this.auth_user) {
      return false;
    }
    const canSecurity = (this.auth_user.cuentas == 1)?true:false;
    return canSecurity;
  }

  canRevertirLiquidacion(){
    if (!this.auth_user) {
      return false;
    }
    return (this.auth_user.revertir_liquidacion == 1)?true:false;
  }

  getFirstPermittedRoute() {
    const token = this.getToken();
    if(!token || !this.auth_user) {
      return 'login';
    }

    let first_permitted = undefined;
    this.auth_user.permisos_usuarios.forEach(p => {
      if (!first_permitted && (p.lectura == 1 || p.lectura == true)) {
        first_permitted = p;
      }
    });


    const module = this.modulesService.find(first_permitted.idPermisos)
    let path = 'login';
    if (module.path) {
      path = module.path;
    } else {
      this.killUser();
    }
    return path;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/autenticacion.service.ts